import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/sales-developer/compound/compounds";
const apiDropDownEndpoint= API_BASE_URL_ENV() + "/admin/compound/dropdown/Compound?status=1"
const apiToggleActivationEndpoint = API_BASE_URL_ENV() + "/sales-developer/compound";

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }

    getDropDown=()=>{
        return  http.get(apiDropDownEndpoint) 
    }

    getCompoundWithResaleDropDown=()=>{
        return  http.get(`${apiDropDownEndpoint}&has_resales=1`) 
    }

    toggleStatus(model, id, params ={}) {
        return http.get(`${apiToggleActivationEndpoint}/toggle-activation/${model}/${id}`, { params });
    }
}
